import * as notificationApi from '@/network/api/notification.api.js'

/** Request list of notifications preferences
@return { promise }
*/
export const requestNotificationPreferencesList = async (context, payload) => {
	const res = await notificationApi.getNotificationsPreferencesList(payload)

	if (res) context.commit('SAVE_NOTIFICATION_PREFERENCES_LIST', res.data)
	return res
}

/** Update notification status
@return { promise }
*/
export const editNotificationStatus = async (context, payload) => {
	const res = await notificationApi.updateNotificationStatus(payload)

	if (res) context.commit('UPDATE_NOTIFICATION_STATUS', payload)
	return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
